import React, { useMemo } from 'react';

// TODO: FB-000000 - we need to remove dependency cycle
// eslint-disable-next-line import/no-cycle
import SectionBlock from 'components/Globals/SectionBlock';
import ProductionListView from 'components/Productions/Common/ProductionListView';

import { transformPastDateFilters } from 'utils/globals/filters';
import useDeviceTypeLayouts from 'utils/hooks/useDeviceTypeLayouts';

import { ENTITY_TYPES, VIEW_MODES } from 'operabase-router/constants';

import classes from './FeaturedProductions.module.scss';

const FeaturedProductions = ({
  title,
  entity,
  entityType,
  filters = {},
  infinite = false,
  limit = 10,
  sectionProps = {},
  trackingData,
}) => {
  const { isDesktop } = useDeviceTypeLayouts();
  const params = useMemo(
    () => ({
      ...filters,
      has_media: true,
      is_cancelled: false,
      mediaLimit: limit,
      ...transformPastDateFilters(),
      ...(entityType === ENTITY_TYPES.PROFILE && { ctx_entity: `a${entity?.id}` }),
      ...(entityType === ENTITY_TYPES.ORGANIZATION && { ctx_entity: `o${entity?.id}` }),
      ...(entityType === ENTITY_TYPES.WORK && { work_id: entity?.id }),
    }),
    [entity?.id, entityType, filters, limit],
  );

  return (
    <SectionBlock title={title} {...sectionProps} styles={{ header: classes.sectionBlockHeader }}>
      <ProductionListView
        overrideFilters={params}
        infinite={infinite}
        limit={limit}
        trackingData={trackingData}
        forcedViewMode={isDesktop ? VIEW_MODES.GRID : VIEW_MODES.MINI}
        hideActions
      />
    </SectionBlock>
  );
};

export default FeaturedProductions;
